import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import {
  Toolbar,
  ToolbarTitle,
} from "@babackapp/customer-ui/components/toolbar";
import { ShoppingBasket } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";

export function SummaryToolbar() {
  const { orderId, shopId } = useWidgetParams();
  const draft = useDraftReturn(orderId);
  const count = draft?.lineItems.length ?? 0;

  if (count === 0) return null;

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0, transition: { type: "spring" } }}
      exit={{ y: 100 }}
      layoutId="summary-toolbar"
      className="absolute bottom-4 w-auto left-4 right-4 flex items-center justify-center"
    >
      <Link to={`/return-widget/${shopId}/order/${orderId}/summary`}>
        <Toolbar>
          <ShoppingBasket />
          <ToolbarTitle>
            {count} article{count > 1 ? "s" : ""} à retourner
          </ToolbarTitle>
        </Toolbar>
      </Link>
    </motion.div>
  );
}
